export const ROUTE_KEY_ATTRIBUTES = 'fa';
export const ROUTE_KEY_BRANDS = 'b';
export const ROUTE_KEY_PRICE_TYPE = 'pt';
export const ROUTE_KEY_PRICE = 'price';
export const ROUTE_KEY_ONLY_AVAILABLE = 'av';

interface IFilterAttribute {
  queryKey: string;
  attributeName: string;
  sortOrder: number;
}

export interface IFilterAttributeChoice extends IFilterAttribute {
  choices: IFilterAttributeChoiceValue[];
}

export interface IFilterAttributeChoiceValue {
  choiceId: string;
  choiceName: string;
  productCount: number;
  sortOrder: number;
  isSelected: boolean;
}

export interface IFilterAttributeRange extends IFilterAttribute {
  rangeUnit: string;
  rangeSteps: number[];
  rangeValues: IFilterAttributeRangeValue;
}

export interface IFilterAttributeRangeValue {
  minimum: number;
  maximum: number;
  minimumCurrent?: number;
  maximumCurrent?: number;
}
